import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';

const CadrageForm = ({ onDataChange, formData = {} }) => {
  const { projectId } = useParams();
  
  // État local pour les données du formulaire (initialisé avec les données persistantes)
  const [localFormData, setLocalFormData] = useState({
    name: formData.name || '',
    numero_tel: formData.numero_tel || '',
    email: formData.email || '',
    adresse: formData.adresse || '',
    reference_chantier: formData.reference_chantier || '',
    post_code: formData.post_code || '',
    project_step: formData.project_step || '',
    project_start_date: formData.project_start_date || '',
    construction_site_ref: formData.construction_site_ref || '',
    has_technician: formData.has_technician || false,
    need_technician: formData.need_technician || false,
    complementary_info: formData.complementary_info || '',
  });
  
  // État local pour les options des selects
  const [projectStepOptions] = useState([
    'Conception',
    'Planification',
    'Exécution',
    'Finalisation'
  ]);
  
  const [technicianOptions] = useState([
    { value: true, label: 'Oui' },
    { value: false, label: 'Non' }
  ]);

  // Synchroniser avec les données persistantes au chargement et quand les props changent
  useEffect(() => {
    setLocalFormData({
      name: formData.name || '',
      numero_tel: formData.numero_tel || '',
      email: formData.email || '',
      adresse: formData.adresse || '',
      reference_chantier: formData.reference_chantier || '',
      post_code: formData.post_code || '',
      project_step: formData.project_step || '',
      project_start_date: formData.project_start_date || '',
      construction_site_ref: formData.construction_site_ref || '',
      has_technician: formData.has_technician || false,
      need_technician: formData.need_technician || false,
      complementary_info: formData.complementary_info || '',
    });
  }, [formData]); // Synchroniser quand les données du parent changent

  // Les données sont automatiquement synchronisées via le hook useFormData

  const handleInputChange = (field, value) => {
    const newData = {
      ...localFormData,
      [field]: value
    };
    setLocalFormData(newData);
    // Notifier le composant parent des changements
    if (onDataChange) {
      onDataChange(newData);
    }
  };

  const handleSelectChange = (field, value) => {
    const newData = {
      ...localFormData,
      [field]: value
    };
    setLocalFormData(newData);
    // Notifier le composant parent des changements
    if (onDataChange) {
      onDataChange(newData);
    }
  };

  return(
    <>
      {/*container*/}
      <div className="container py-5">
        <div className="py-5">
          <p className="page-title text-center">Information préalable :</p>
          <p className="grey-text text-center">
            En tant que négoce, nous ne nous substituons pas au maitre d’œuvre. Nous
            ne réalisons pas les <br /> plans de permis de construire et ne faisons
            pas de pose sur chantier.
          </p>
        </div>
      </div>
      <div className="container">
        <div className="form-head">
          <p className="text-center">
            Veuillez renseigner les informations suivantes pour nous aider à mieux
            comprendre votre demande
          </p>
        </div>
        <div className="be-form p-3 p-md-5">
          <form>
            {/* Informations personnelles */}
            <div className="row mb-4">
              <div className="col-12">
                <h6 className="be-form-p mb-3">Informations personnelles</h6>
              </div>
              <div className="col-md-4 col-12 mb-3">
                <p className="be-form-p">Nom complet</p>
                <input 
                  type="text" 
                  className="p-3" 
                  value={localFormData.name}
                  onChange={(e) => handleInputChange('name', e.target.value)}
                  placeholder="Votre nom complet"
                />
              </div>
              <div className="col-md-4 col-12 mb-3">
                <p className="be-form-p">Numéro de téléphone</p>
                <input 
                  type="tel" 
                  className="p-3" 
                  value={localFormData.numero_tel}
                  onChange={(e) => handleInputChange('numero_tel', e.target.value)}
                  placeholder="Votre numéro de téléphone"
                />
              </div>
              <div className="col-md-4 col-12 mb-3">
                <p className="be-form-p">Email</p>
                <input 
                  type="email" 
                  className="p-3" 
                  value={localFormData.email}
                  onChange={(e) => handleInputChange('email', e.target.value)}
                  placeholder="Votre adresse email"
                />
              </div>
            </div>

            {/* Informations du chantier */}
            <div className="row mb-4">
              <div className="col-12">
                <h6 className="be-form-p mb-3">Informations du chantier</h6>
              </div>
              <div className="col-md-8 col-12 mb-3">
                <p className="be-form-p">Adresse du Chantier</p>
                <input 
                  type="text" 
                  className="p-3" 
                  value={localFormData.adresse}
                  onChange={(e) => handleInputChange('adresse', e.target.value)}
                  placeholder="Entrez l'adresse du chantier"
                />
              </div>
              <div className="col-md-4 col-12 mb-3">
                <p className="be-form-p">Code Postal</p>
                <input 
                  type="number" 
                  className="p-3" 
                  value={localFormData.post_code}
                  onChange={(e) => handleInputChange('post_code', e.target.value)}
                  placeholder="Code postal"
                />
              </div>
            </div>
            <div className="row mt-5">
              <div className="col-md-8 col-12 mb-3">
                <p className="be-form-p">
                  À quelle étape de votre projet êtes-vous ?
                </p>
                <select 
                  className="form-select p-2"
                  value={localFormData.project_step}
                  onChange={(e) => handleSelectChange('project_step', e.target.value)}
                >
                  <option value="">Choisir une option</option>
                  {projectStepOptions.map((option, index) => (
                    <option key={index} value={option}>{option}</option>
                  ))}
                </select>
              </div>
              <div className="col-md-4 col-12 mb-3">
                <p className="be-form-p">Date prévisionnelle du Chantier</p>
                <input 
                  type="date" 
                  className="p-3" 
                  value={localFormData.project_start_date}
                  onChange={(e) => handleInputChange('project_start_date', e.target.value)}
                />
              </div>
            </div>
            <hr className="my-5" />
            <div className="row mb-5">
              <div className="col-12 mb-3">
                <p className="be-form-p">Reference de Chantier</p>
                <input 
                  type="text" 
                  className="p-3" 
                  value={localFormData.reference_chantier}
                  onChange={(e) => handleInputChange('reference_chantier', e.target.value)}
                  placeholder="Référence du chantier"
                />
              </div>
            </div>
            <div className="row mb-4">
              <div className="col-md-6 col-12 mb-3">
                <p className="be-form-p">Etes vous un professionnel du bâtiment ?</p>
                <select 
                  className="form-select p-2"
                  value={localFormData.has_technician}
                  onChange={(e) => handleSelectChange('has_technician', e.target.value === 'true')}
                >
                  <option value="">Choisir une option</option>
                  {technicianOptions.map((option, index) => (
                    <option key={index} value={option.value}>{option.label}</option>
                  ))}
                </select>
              </div>
              <div className="col-md-6 col-12 mb-3">
                <p className="be-form-p">Etes vous déjà client Rullier ?</p>
                <select 
                  className="form-select p-2"
                  value={localFormData.need_technician}
                  onChange={(e) => handleSelectChange('need_technician', e.target.value === 'true')}
                >
                  <option value="">Choisir une option</option>
                  {technicianOptions.map((option, index) => (
                    <option key={index} value={option.value}>{option.label}</option>
                  ))}
                </select>
              </div>
            </div>
            {/* <span className="grey-text" style={{ fontSize: 12 }}>
              Un poseur est très fortement recommandé pour cette typologie de projet
            </span> */}
          </form>
        </div>
      </div>
    </>
  )
}

export default CadrageForm